import { Flex } from '@mantine/core'

import AnimatedPrice from '@/components/AnimatedPrice'
import type { CoinOverall } from '@/types/coin'

import { useCoinsTableStore } from '../../context'

interface Props {
  coin: Pick<CoinOverall, 'usd_price' | 'symbol' | 'slug'>
}

export default function PriceColumn({ coin }: Props) {
  const liveUsdPrice = useCoinsTableStore(state => state.liveCoinsMarket[coin.slug]?.usd_price)
  const showPrice = liveUsdPrice ?? coin.usd_price
  return (
    <Flex justify="flex-end">
      <AnimatedPrice
        variant={'body-number'}
        price={showPrice}
        tokenSymbol={coin.symbol}
        maw="130px"
        truncate
      />
    </Flex>
  )
}
